var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Three60Environment',{attrs:{"panos":_vm.pageData.future.panoramas,"heading":_vm.pageData.future.heading,"copy":_vm.pageData.future.overview}})
}
var staticRenderFns = []

export { render, staticRenderFns }